import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer dialog-footer-two-btn" }

import { useI18n } from 'vue-i18n';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { format } from '@/utils/format';
import { useUtils, setNestedDialogOpen } from '@/composables/utils/useUtils';
import Icon from '@/components/icon/Icon.vue';
import HighRatesDetails from '@/components/highRatesLearnMore/HighRatesDetails.vue';
import { HIGH_RATES_LEARN_MORE } from '@/constants/EXTERNAL_LINKS';


export default /*#__PURE__*/_defineComponent({
  __name: 'LearnMoreDialog',
  props: {
    type: null,
    asLink: { type: Boolean },
    asIcon: { type: Boolean },
    dataSource: null
  },
  setup(__props: any) {

const props = __props as {
  type: string;
  asLink?: boolean;
  asIcon?: boolean;
  dataSource: string;
}


const { t } = useI18n();
const { state } = useStore();
const { openExternalLink } = useUtils();

const isShowDialog = ref(false);
const onDialogOpen = () => {
  isShowDialog.value = true;
  setNestedDialogOpen(true);
};
const onDialogClose = () => {
  setNestedDialogOpen(false);
  isShowDialog.value = false;
};

const aprWeights = computed(() => {
  return state[props.dataSource].aprWeights;
});

const tvlLevels = computed(() => {
  const tvlLevels = state[props.dataSource].tvlLevels;
  return tvlLevels.map(level => format(level).toUpperCase());
});
const openDocs = () => {
  openExternalLink(HIGH_RATES_LEARN_MORE);
  onDialogClose();
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.asLink)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          class: "button-text text-sm text-primary",
          label: _ctx.$t('learnMore'),
          onClick: onDialogOpen
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    (__props.asIcon)
      ? (_openBlock(), _createBlock(Icon, {
          key: 1,
          name: "learnMore",
          class: "button-icon learn-more-icon mx-s1",
          onClick: onDialogOpen,
          size: "16"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: isShowDialog.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isShowDialog).value = $event)),
      header: _unref(t)('learnMoreDialog.header', { type: __props.type }),
      modal: true,
      "content-class": _unref(state).layout.isMobile ? 'scroll-container' : '',
      dismissableMask: "",
      onHide: _cache[1] || (_cache[1] = ($event: any) => (_unref(setNestedDialogOpen)(false)))
    }, {
      default: _withCtx(() => [
        _createVNode(HighRatesDetails, {
          "apr-weights": _unref(aprWeights),
          "tvl-levels": _unref(tvlLevels),
          type: __props.type,
          "no-link": ""
        }, null, 8, ["apr-weights", "tvl-levels", "type"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Button, {
            class: "button-base",
            label: _ctx.$t('close'),
            onClick: onDialogClose
          }, null, 8, ["label"]),
          _createVNode(_component_Button, {
            class: "button-primary",
            label: _ctx.$t('readDocs'),
            onClick: openDocs
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('readDocs')), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header", "content-class"])
  ], 64))
}
}

})